import { useState, useEffect } from 'react';
import { IS_PROD, IS_PRE } from '@zero/mc-utils';
import Api from '../../pages/activity-manage/merchants/detail/components/sale-activity/apis';

export const couponLevelSettingTemplateId = IS_PROD || IS_PRE ? 54 : 168; // 非商城体系下优惠券层级配置模板Id
export const thresholdPriceTemplateId = IS_PROD || IS_PRE ? 57 : 187; // 主题年货节活动接入90天优惠路径白名单配置模板Id

export default function useTemplateSchema(props) {
  const { templateId } = props || {};
  const [schema, setSchema] = useState({});
  useEffect(() => {
    if (!templateId) return;
    Api.getTemplateSchema(templateId).then((res) => {
      if (res && res.success && res.data) {
        setSchema(res.data);
      }
    });
  }, [templateId]);

  return schema || {};
}
